import React from 'react';
function ElmoHome() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M12,5.7l5,4.5V18h-2v-6H9v6H7v-7.8L12,5.7 M12,3L2,12h3v8h6v-6h2v6h6v-8h3L12,3z" })));
}
export default ElmoHome;
